import React, { useContext, useState, useEffect } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import { Button, Input } from "antd";
import { AuthContext } from "../../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";


const EditPagamento = (props) => {

  const styles = `
.Maquinas-page {
  background-color: black;
  color: white;
  margin: 0;
  padding: 0;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100vw;
  overflow: auto;   
}
.Edit_content {
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  max-width: 400px;
  padding: 30px;
  margin-left: 0; 
}
.Edit_header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 20px 20px 20px;
  gap: 30px;
}
.Edit_header_title {
  background-color: transparent !important;
  color: rgb(250, 247, 83) !important;
  border-radius: 5px !important;
  text-align: left !important;
  line-height: 1 !important;
  height: auto; 
  display: flex !important;
  align-items: center !important;
  font-size: 30px;
  margin-top: 50px;
}
.Botao-Voltar {
  font-size: 20px;
  padding: 12px 30px;
  align-items: center; 
  justify-content: center;
  text-align: center; 
  border-radius: 10px;
  border: none;
  font-weight: bold;
  background-color: rgb(163, 3, 163);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 50px;
  border: 1px solid #ffffff;
  display: inline-flex;
  width: auto !important; 
  max-width: fit-content !important; 
  white-space: nowrap; 
}
.Botao-Voltar:hover {
  background-color: rgb(250, 31, 250);
}
.Edit_itemField {
  padding: 10px 0px;
  width: 100%;
}
.Edit_itemField input {
  border: 1px solid #55b962;
  border-radius: 4px;
  background-color: rgb(248, 249, 250);
}
.Edit_itemField input .Edit_inputError {
  border: 1px solid #e46772;
}
.Edit_itemFieldError {
  color: #e46772;
  font-size: 14px;
  padding: 2px 0;
}
.Edit_storeLabel {
  display: flex;
}
.Edit_Icon {
  width: 23px;
  height: 23px;
  margin-left: 7px;
}
.Edit_container {
  padding: 20px;
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
}
.Edit_editBtn {
  display: flex !important;
  align-items: center;
}
.Edit_editBtn span {
  margin-left: 5px;
}
.Edit_back {
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  text-decoration: underline;
  color: rgb(118, 120, 122);
}
.Edit_staBlockTitle {
  font-weight: 400;
  font-size: 24px;
  line-height: 27px;
  padding: 10px 15px;
}
.Edit_Icon {
  cursor: pointer;
  width: 22px;
  margin-left: 10px;
  margin-bottom: 0.5rem;
}
.EditLabel_Icon {
  display: flex;
  align-items: center;
}
.custom-datepicker input::placeholder {
  color: black !important;
  opacity: 1; 
}
.Botao-Salvar {
  margin-top: 20px;
  background-color: rgb(6, 128, 2);
  color: #fff;
  border-radius: 4px;
  width: 100%;
  border: 1px solid #ffffff;
  display: flex; 
  align-items: center; 
  justify-content: center;
  text-align: center;  
}
.Botao-Salvar:hover {
  background-color: rgb(78, 247, 100);
  color: #fff;
}
  `;


    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const location = useLocation();

  let navigate = useNavigate();

  const { authInfo, setNotiMessage } = useContext(AuthContext);

  const [data, setData] = useState({
    nome: localStorage.getItem(`Textonome`) ?? "",
    descricao: localStorage.getItem(`Textodescricao`) ?? "",
    valpelucia: localStorage.getItem(`Valorpelucia`) ?? 20,
    valorDoPulso: localStorage.getItem(`Valorcredito`) ?? 1,
    limitetrava: localStorage.getItem(`Valortrava`) ?? 40,
    pulsotentativa: localStorage.getItem(`Valortentativa`) ?? 2,
    estoque: localStorage.getItem(`Valorestoque`) ?? 100,
  });
  const [errors, setErrors] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();
  // 
  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = () => {

    let errorsTemp = {};
    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }

    if (data.descricao.trim() === "") {
      errorsTemp.descricao = "Este campo é obrigatório";
    }

    if (data.valorDoPulso < 1) {
      errorsTemp.valorDoPulso = "Este campo é obrigatório 04";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_SERVIDOR}/maquina-cliente`,
        {
          id,
          nome: data.nome,
          descricao: data.descricao,
          estoque: Number(data.estoque),
          valorDoPulso: data.valorDoPulso,
          valpelucia: Number(data.valpelucia), // Pelucia
          pulsotentativa: Number(data.pulsotentativa), // Pelucia
          limitetrava: Number(data.limitetrava), // Pelucia
        },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        navigate(`/dashboard-maquinas`);
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "Sua sessão expirou, faça login novamente. 11",
          });
        } else if (err.response.status === 400) {
          setNotiMessage({
            type: "error",
            message: "Já existe uma máquina com esse nome",
          });
          setErrors((prev) => ({
            ...prev,
            nome: "Já existe uma máquina com esse nome",
          }));
        } else {
          setNotiMessage({
            type: "error",
            message: "Um erro ocorreu",
          });
        }
      });
  };

  return (
    <div className="Maquinas-page">
      {isLoading && <LoadingAction />}
      <div className="Edit_header">
        <div className="Edit_header_title">EDITAR MÁQUINA</div>
        <Button
          className="Botao-Voltar"
          onClick={() => {
            navigate(`/pagamentos/${id}`, {
              state: location.state,
            });
          }}
        >
          <span>VOLTAR</span>
        </Button>
      </div>

      <div className="Edit_content">
        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="nome">
            Nome:
          </label>
          <Input
            // placeholder={"Máquina do Fulano de Tal"}
            value={data.nome}
            id="nome"
            type="text"
            name="nome"
            autoComplete="nome"
            onChange={(event) => {
              handleChange("nome", event.target.value);
            }}
            className={`${!!errors.nome ? "Edit_inputError" : ""}`}
          />
          {errors.nome && (
            <div className="Edit_itemFieldError">{errors.nome}</div>
          )}
        </div>
        <div className="Edit_itemField">
          <label
            className="Edit_itemFieldLabel"
            htmlFor="descricao"
          >
            Descricão:
          </label>
          <Input
            // placeholder={"Está no Endereço Tal"}
            value={data.descricao}
            id="descricao"
            type="text"
            name="descricao"
            autoComplete="descricao"
            onChange={(event) => {
              handleChange("descricao", event.target.value);
            }}
            className={`${!!errors.descricao ? "Edit_inputError" : ""
              }`}
          />
          {errors.descricao && (
            <div className="Edit_itemFieldError">
              {errors.descricao}
            </div>
          )}
        </div>
        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="valorDoPulso">
            Valor em Reais para dar 01 Pulso:
          </label>
          <Input
            // placeholder={"1"}
            value={data.valorDoPulso}
            id="valorDoPulso"
            type="number"
            name="valorDoPulso"
            autoComplete="valorDoPulso"
            onChange={(event) => {
              handleChange("valorDoPulso", event.target.value);
            }}
            className={`${!!errors.valorDoPulso ? "Edit_inputError" : ""
              }`}
          />
          {errors.valorDoPulso && (
            <div className="Edit_itemFieldError">
              {errors.valorDoPulso}
            </div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="pulsotentativa">
            Valor em Reais para 01 Tentativa:
          </label>
          <Input
            // placeholder={"2"}
            value={data.pulsotentativa}
            id="pulsotentativa"
            type="number"
            name="pulsotentativa"
            autoComplete="pulsotentativa"
            onChange={(event) => {
              handleChange("pulsotentativa", event.target.value);
            }}
            className={`${!!errors.pulsotentativa ? "Edit_inputError" : ""
              }`}
          />
          {errors.pulsotentativa && (
            <div className="Edit_itemFieldError">
              {errors.pulsotentativa}
            </div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="valpelucia">
            Valor em Reais Da Pelúcia:
          </label>
          <Input
            // placeholder={"10"}
            value={data.valpelucia}
            id="valpelucia"
            type="number"
            name="valpelucia"
            autoComplete="valpelucia"
            onChange={(event) => {
              handleChange("valpelucia", event.target.value);
            }}
            className={`${!!errors.valpelucia ? "Edit_inputError" : ""
              }`}
          />
          {errors.valpelucia && (
            <div className="Edit_itemFieldError">
              {errors.valpelucia}
            </div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="limitetrava">
            Limite da Trava:
          </label>
          <Input
            // placeholder={"40"}
            value={data.limitetrava}
            id="limitetrava"
            type="number"
            name="limitetrava"
            autoComplete="limitetrava"
            onChange={(event) => {
              handleChange("limitetrava", event.target.value);
            }}
            className={`${!!errors.limitetrava ? "Edit_inputError" : ""
              }`}
          />
          {errors.limitetrava && (
            <div className="Edit_itemFieldError">
              {errors.limitetrava}
            </div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="estoque">
            Estoque:
          </label>
          <Input
            // placeholder={"100"}
            value={data.estoque}
            id="estoque"
            type="number"
            name="estoque"
            autoComplete="estoque"
            onChange={(event) => {
              handleChange("estoque", event.target.value);
            }}
            className={`${!!errors.estoque ? "Edit_inputError" : ""
              }`}
          />
          {errors.estoque && (
            <div className="Edit_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
        <Button
          className="Botao-Salvar"
          onMouseEnter={(e) => (e.target.style.color = "#fff")}
          onMouseLeave={(e) => (e.target.style.color = "#fff")}
          onClick={() => {
            if (!isLoading) onSave();
          }}
          disabled={isLoading}
        >
          SALVAR ALTERAÇÕES
        </Button>
      </div>
    </div>
  );
};

export default EditPagamento;